import produce from 'immer';
import {
  types,
  MaintenanceState,
  MaintenanceActionTypes,
  SetKioskHardwareIdOutOfStock,
  SetLastPrintedOrderDetails
} from './types';

// Actions
export const actions = {
  setKioskHardwareIdOutOfStock: (payload: string) => ({ type: types.SET_KIOSK_HARDWARE_ID_OUT_OF_STOCK, payload }),
  setLastPrintedOrderDetails: (payload: SetLastPrintedOrderDetails['payload']) => ({
    type: types.SET_LAST_PRINTED_ORDER_DETAILS,
    payload
  }),
  resetMaintenance: () => ({ type: types.RESET_MAINTENANCE })
};

// Initial State
export const initialState: MaintenanceState = {
  kioskHardwareIdOutOfStock: undefined,
  lastPrintedOrderDetails: null
};

// Reducer
export const reducer = (state: MaintenanceState = initialState, action: MaintenanceActionTypes): MaintenanceState => {
  // eslint-disable-next-line consistent-return
  return produce(state, (draft) => {
    switch (action.type) {
      case types.SET_KIOSK_HARDWARE_ID_OUT_OF_STOCK:
        draft.kioskHardwareIdOutOfStock = (action as SetKioskHardwareIdOutOfStock).payload;
        break;
      case types.SET_LAST_PRINTED_ORDER_DETAILS:
        draft.lastPrintedOrderDetails = (action as SetLastPrintedOrderDetails).payload;
        break;
      case types.RESET_MAINTENANCE:
        return {
          ...initialState,
          lastPrintedOrderDetails: state.lastPrintedOrderDetails
        };
      default:
    }
  });
};
